import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f5c51eb4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f5c51eb4&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=f5c51eb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_398719d9ba0fb65ce1cea3b2910bec76/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c51eb4",
  null
  
)

export default component.exports